import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UpdateMinuteApprovalConditionRequest, UpdateMinuteRequestApprovalRuleConditionViewModel } from '../../interfaces/minute-request-approval-rule-manage.interface';
import { MinuteRequestApprovalRuleService } from '../../services/minute-request-approval-rule.service';
import { Observable } from 'rxjs';
import { MinuteApprovalParameterConstraintViewModel, MinuteApprovalParameterDTO } from '../../interfaces/minue-request-approval-paramters.interface';
import { MinuteApprovalConditionComparator } from '../../interfaces/minute-request-approval-rule.interface';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-update-minute-request-approval-rule-condition',
  templateUrl: './update-minute-request-approval-rule-condition.component.html',
  styleUrl: './update-minute-request-approval-rule-condition.component.scss'
})
export class UpdateMinuteRequestApprovalRuleConditionComponent implements OnInit{

  public updateConditionGroup: FormGroup;
  public comparators = MinuteApprovalConditionComparator;
  public parameters: MinuteApprovalParameterDTO[] = [];
  public constraintParameter: MinuteApprovalParameterConstraintViewModel | null;


  constructor(private dialogRef: MatDialogRef<UpdateMinuteRequestApprovalRuleConditionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: UpdateMinuteRequestApprovalRuleConditionViewModel,
    private minuteRequestApprovalRuleService: MinuteRequestApprovalRuleService,
    private fb: FormBuilder
  ) {
    this.updateConditionGroup = this.fb.group({
      parameter: [this.data.minuteRequestApprovalParameterId, Validators.required],
      comparator: [this.data.comparator, Validators.required],
      value: [this.data.value, Validators.required]
    });
  }

  ngOnInit(): void {
    this.getParameters();
    this.updateConditionGroup.get('parameter').valueChanges
    .subscribe((newParameterId: number) => {
      this.updateConstraintParameter(newParameterId);
    });
  }

  private updateConstraintParameter(parameterId: number){
    const {value, comparator} = this.updateConditionGroup.value;
    const newParamSelected = this.parameters.find(p => p.minuteApprovalParameterId === parameterId);
    const newConstraints: MinuteApprovalParameterConstraintViewModel = {
      allowedValues: new Map(Object.entries(newParamSelected?.constraint.allowedValues).map(([k,v]) => [+k,v])),
      allowedComparators: new Map([...MinuteApprovalConditionComparator].filter(([key, _])=>  newParamSelected.constraint.allowedComparators.includes(key)))
    };

    // Avoid checking and reseting value and comparator on the first change
    if(this.constraintParameter != null){
      const resetValue: boolean = newConstraints.allowedValues.size == 0 || !newConstraints.allowedValues.has(this.updateConditionGroup.get('value')?.value);
      const resetComparator: boolean = !newConstraints. allowedComparators.has(this.updateConditionGroup.get('comparator')?.value);
      this.updateConditionGroup.patchValue({
        comparator: resetComparator ? null: comparator,
        value: resetValue ? null : value
      });  
    }
    this.constraintParameter = newConstraints;

  }

  public getParameters() {
    this.minuteRequestApprovalRuleService.getAllMinuteApprovalParameters()
    .subscribe((params) => {
      this.parameters = params;
      if(this.constraintParameter == null){
        this.updateConstraintParameter(this.data.minuteRequestApprovalParameterId);
      }
    });
  }

  public clickCloseDialog(){
    this.dialogRef.close(false);
  }

  public submit() {
    const { parameter, comparator, value } = this.updateConditionGroup.value;
    const request: UpdateMinuteApprovalConditionRequest = {
      minuteRequestApprovalParameterId: parameter,
      comparator: comparator,
      value: value
    };
    const updateCondition$ = this.minuteRequestApprovalRuleService.updateMinuteApprovalCondition(this.data.minuteRequestApprovalRuleId, this.data.minuteRequestApprovalConditionId, request)
    Swal.fire({
      title: 'Modificando condición',
      didOpen: () => {
        Swal.showLoading();
        updateCondition$.subscribe({
          next: (res) => {
            Swal.fire({
              icon: 'success',
              title: res.resultMessage,
              didClose: () => this.dialogRef.close(true)
            });
          },
          error: (err) => {
            Swal.fire({
              icon: 'error',
              title: err.error.resultMessage,
            })
          }
        })

      }
    })
  }

  
}
